<template>
  <div class="py-5 px-2 px-sm-8">
    <v-row>
      <v-col :xs="12" :sm="3" :md="2" :cols="12">
        <div class="font-weight-bold secondary--text">{{ $t('label.visitedDate') }}</div>
        <div class="font-weight-medium secondary--text text--lighten-2 mt-2">{{ posTrasaction.visited_date | shortDate }}</div>
      </v-col>
      <v-col :xs="12" :sm="9" :md="10" :cols="12">
        <div class="font-weight-bold secondary--text">{{ $t('label.salonAndStylist') }}</div>
        <div class="d-flex align-center mt-1">
          <div class="font-weight-medium secondary--text text--lighten-3">{{ posTrasaction.branch_name }}</div>
          <v-btn
            v-if="toReview"
            color="primary"
            dense
            class="ml-auto px-4 px-sm-10 rounded-pill green-gradient-right text-capitalize align-self-center"
            :to="{ name: $constants.ROUTE_NAME.SALON_STYLIST_REVIEW_NEW, params: { posTransactionId: posTrasaction.pos_transaction_id } }"
          >
            {{ $t('button.writeReview') }}
          </v-btn>
        </div>
        <div v-if="!toReview">
          <Rating :value="posTrasaction.branch_star" class="my-3" dense readonly />
          <div class="font-weight-medium secondary--text text--lighten-3 mb-4">{{ posTrasaction.branch_comment }}</div>
          <div v-for="staff in posTrasaction.item" :key="staff.staff_id" class="mt-8">
            <div class="font-weight-medium secondary--text text--lighten-3">{{ staff.staff_name }}</div>
            <Rating :value="staff.staff_star" class="my-3" dense readonly />
            <div class="font-weight-medium secondary--text text--lighten-3">{{ staff.staff_comment }}</div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-divider v-if="!toReview || (toReview && !$vuetify.breakpoint.smAndUp)" class="mt-8"></v-divider>
  </div>
</template>

<script>
import Rating from '@/components/Rating.vue'
export default {
  props: {
    posTrasaction: {
      type: Object,
      required: true
    },
    toReview: {
      type: Boolean,
      default: true
    }
  },
  components: { Rating }
}
</script>
